import { NgModule } from '@angular/core';

import { MgModalService } from './MgModal.service';

@NgModule({
  providers: [MgModalService],
})
export class MgModalModule {}
